import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { FrameComponent } from './frame/frame.component';
import { PedidoEnviadoComponent } from './modulos/pedidos/modulos/criar-editar/pedido-enviado/pedido-enviado.component';

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always'
}

const routes: Routes = [
    {
        path: ':realm', component: FrameComponent, children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'pedidos'
            },
            {
                path: 'pedidos',
                loadChildren: () => import('./modulos/pedidos/pedidos.module').then(m => m.PedidosModule),
                data:
                {
                    icon: 'pi pi-box',
                    label: 'Pedidos',
                }
            }
            // {
            //     path: 'configuracoes',
            //     loadChildren: () => import('./modulos/configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule),
            //     data:
            //     {
            //         icon: 'pi pi-cog',
            //         label: 'Configurações',
            //     }
                
            // },
            // {
            //     path:  'faq',
            //     loadChildren: () => import('./modulos/faq/faq.module').then(m => m.FaqModule),
            //     data:
            //     {
            //         icon: 'pi pi-question-circle',
            //         label: 'FAQ'
            //     }
            // },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }